import axios from '@/_services/axios';

export function Create(item) {
  return new Promise((resolve, reject) => {
    axios
      .post('userMaterials', {
        name: item.name,
        unitId: item.unitId,
        unitPrice: item.unitPrice,
        laborConstant: item.laborConstant,
        laborId: item.laborId,
        compositePrototypeIds: item.compositePrototypeIds,
      })
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function GetAllPaging(take, skip) {
  return new Promise((resolve, reject) => {
    axios
      .get(`userMaterials?take=${take}&skip=${skip}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function GetSearch(text, take, skip) {
  return new Promise((resolve, reject) => {
    axios
      .get(`userMaterials?take=${take}&skip=${skip}&searchParam=${text}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function Get(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`userMaterials/${id}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function Edit(item) {
  return new Promise((resolve, reject) => {
    axios
      .put(`userMaterials/${item.id}`, {
        name: item.name,
        unitId: item.unitId,
        unitPrice: item.unitPrice,
        laborConstant: item.laborConstant,
        laborId: item.laborId,
        compositePrototypeIds: item.compositePrototypeIds,
      })
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function Delete(id) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`userMaterials/${id}`, { responseType: 'text' })
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}
